import { render } from "./AcceptCertificate.vue?vue&type=template&id=1cea9aaa&scoped=true"
import script from "./AcceptCertificate.vue?vue&type=script&lang=js"
export * from "./AcceptCertificate.vue?vue&type=script&lang=js"

import "./AcceptCertificate.vue?vue&type=style&index=0&id=1cea9aaa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cea9aaa"]])

export default __exports__